import { render, staticRenderFns } from "./AdminControlPanel.vue?vue&type=template&id=9459a84c&"
import script from "./AdminControlPanel.vue?vue&type=script&lang=js&"
export * from "./AdminControlPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports